import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <div className="centre">
      <div className="centre__box card stack">
        <h1>Page not found</h1>
        <p className="muted">The link is wrong, or this screen does not exist yet.</p>
        <Link to="/" className="btn">
          Go to overview
        </Link>
      </div>
    </div>
  );
}
